import React from "react";
import awaazWebp from "../assets/Images/awaaz.webp";
import awaaz from "../assets/Images/awaaz.png";
import surgeWebp from "../assets/Images/surge.webp";
import surge from "../assets/Images/surge.png";
import classplusLeadersWebp from "../assets/Images/classplus-leaders.webp";
import classplusLeaders from "../assets/Images/classplus-leaders.png";
import "../index.css";

const KnowMoreSection = () => {
  return (
    <div className="KnowMore__section font-sans">
      <h3>Classplus is appreciated by National and International Media</h3>
      <div className="KnowMore__section__images">
        <div className="KnowMore__section__images__singleImageWithText">
          <a href="https://www.youtube.com/watch?v=c29sUV6bU00">
            <picture>
              <source srcset={awaazWebp} type="image/webp" />
              <source srcset={awaaz} type="image/png" />
              <img src={awaaz} class="img-fluid" alt="Video screenshot" />
            </picture>
          </a>
          {/* <img src={Twitteratis} alt="blumeVenture" /> */}
          <h4>Classplus Success Story</h4>
        </div>
        <div className="KnowMore__section__images__singleImageWithText">
          <a href="https://www.youtube.com/watch?v=Ho0VhwqEQuA">
            <picture>
              <source srcset={surgeWebp} type="image/webp" />
              <source srcset={surge} type="image/png" />
              <img src={surge} class="img-fluid" alt="Video screenshot" />
            </picture>
          </a>

          {/* <img src={Mukul} alt="Sequoia" /> */}
          <h4>Classplus Amping up teacher’s superpowers</h4>
        </div>
        <div className="KnowMore__section__images__singleImageWithText">
          <a href="https://www.youtube.com/watch?v=hdPGsraStTI">
            <picture>
              <source srcset={classplusLeadersWebp} type="image/webp" />
              <source srcset={classplusLeaders} type="image/png" />
              <img
                src={classplusLeaders}
                class="img-fluid"
                alt="Video screenshot"
              />
            </picture>
          </a>

          {/* <img src={expClassplus} alt="Know the Clan" /> */}
          <h4>Classplus Leaders of Tomorrow</h4>
        </div>
      </div>
    </div>
  );
};

export default KnowMoreSection;
